import { defineMessages } from "react-intl"

export const navigationMessages = defineMessages({
	accountSettings: {
		defaultMessage: "Account",
		id: "mainNavigation.settings.account",
	},
	analytics: {
		defaultMessage: "Analytics",
		id: "mainNavigation.analytics",
	},
	buildsheets: {
		defaultMessage: "Build Sheets",
		id: "mainNavigation.buildsheets",
	},
	/** @deprecated currently unused? */
	configurator: {
		defaultMessage: "Configurator",
		id: "mainNavigation.configurator",
	},
	configuratorDealerMode: {
		defaultMessage: "Dealer Mode Configurator",
		id: "mainNavigation.configuratorDealerMode",
	},
	contractualAgreements: {
		defaultMessage: "Additional Agreements",
		id: "mainNavigation.settings.contractualAgreements",
	},
	dealerContactDetailsSettings: {
		defaultMessage: "Contact Details",
		id: "mainNavigation.dealerContactDetailsSettings",
	},
	dealerFeesAndAccessories: {
		defaultMessage: "Fees and Accessories",
		id: "mainNavigation.settings.dealerFeesAndAccessories",
	},
	deliveredVehiclesList: {
		defaultMessage: "Delivered Vehicles",
		id: "mainNavigation.deliveredVehiclesList",
	},
	extraCosts: {
		defaultMessage: "Dealer Fees",
		id: "mainNavigation.settings.extraCosts",
	},
	fulfillmentDeliveredVehiclesList: {
		defaultMessage: "Delivered Vehicles",
		id: "mainNavigation.fulfillmentDeliveredVehiclesList",
	},
	inventoryIntegrationMonitor: {
		defaultMessage: "Inventory Feed Sync Status",
		id: "mainNavigation.inventoryIntegrationMonitor",
	},
	inventoryLinks: {
		defaultMessage: "Showroom",
		id: "mainNavigation.inventoryLinks",
	},
	inventoryList: {
		defaultMessage: "Stocklist",
		id: "mainNavigation.inventoryList",
	},
	notificationsAndTasks: {
		defaultMessage: "Notifications and Tasks",
		id: "mainNavigation.notificationsAndTasks",
	},
	notificationSettings: {
		defaultMessage: "Notifications",
		id: "mainNavigation.settings.notificationSettings",
	},
	offers: {
		defaultMessage: "Offers",
		id: "mainNavigation.offers",
	},
	onlineReservations: {
		defaultMessage: "Online Reservations",
		id: "mainNavigation.onlineOrders", // TODO: change key to mainNavigation.onlineReservations
	},
	pcss: {
		defaultMessage: "PCSS",
		id: "mainNavigation.pcss",
	},
	purchaseRequests: {
		defaultMessage: "Purchase Requests",
		id: "mainNavigation.purchaseRequests",
	},
	requests: {
		defaultMessage: "Requests",
		id: "mainNavigation.requests",
	},
	salesList: {
		defaultMessage: "Sold Vehicles",
		id: "mainNavigation.salesList",
	},
	savedConfigurationsOverview: {
		defaultMessage: "Saved Configurations",
		id: "mainNavigation.savedConfigurationsOverview",
	},
	settings: {
		defaultMessage: "Settings",
		id: "mainNavigation.settings",
	},
	tradeIn: {
		defaultMessage: "Trade-in Requests",
		id: "mainNavigation.tradeIn",
	},
	vehicleHistory: {
		defaultMessage: "Vehicle History",
		id: "mainNavigation.vehicleHistory",
	},
	vehicleInformation: {
		defaultMessage: "Vehicle Information",
		id: "mainNavigation.vehicleInformation",
	},
	vehicleManagement: {
		defaultMessage: "Vehicle Management",
		id: "mainNavigation.vehicleManagement",
	},
	vehicleMediaList: {
		defaultMessage: "Vehicle Media List",
		id: "mainNavigation.vehicleMediaList",
	},
})
